import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Importa o seu componente principal App
import { ThemeProvider } from '@mui/material/styles'; // Para aplicar seu tema
import CssBaseline from '@mui/material/CssBaseline'; // Para um reset de CSS e estilos base
import theme from './theme'; // Importa seu arquivo de tema personalizado

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* CssBaseline lida com um CSS de linha de base bonito para você */}
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);